export default "__VITE_ASSET__75bc8678__"